import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-switches',
  templateUrl: './switches.component.html',
  styleUrls: ['./switches.component.scss'],
})
export class SwitchesComponent implements OnInit {

  @Input() labelOne = ''
  @Input() labelTwo = ''
  @Output() toggleOne = new EventEmitter<{ active: boolean, option: number }>()
  @Output() toggleTwo = new EventEmitter<{ active: boolean, option: number }>()
  public optionOneActive = false
  public optionTwoActive = false

  constructor() { }

  ngOnInit() {
  }

  public switchChange(event: any, option: number) {
    const active = event.detail ? event.detail.checked : false
    if (active) {
      this.toggleOne.emit({ active, option })
    } else {
      if (!this.optionOneActive && !this.optionTwoActive) {
        this.toggleOne.emit({ active: false, option })
      }
    }
  }

  public switchActive(option: number) {
    switch (option) {
      case 1:
        this.optionTwoActive = false
        break
      case 2:
        this.optionOneActive = false
        break
    }
  }

}
